<template>
    <div class="register-page">
        <div class="register-container">
            <!-- Header avec logo texte -->
            <div class="register-header">
                <router-link :to="{ name: 'trips' }" class="logo-link">
                    <h1 class="app-name">MyEcoCar</h1>
                </router-link>
                <p class="register-subtitle">{{ $t('RegistrarNuevoUsuario') }}</p>
            </div>

            <div class="register-form" v-if="!success">
            <div class="register-form" v-if="!success">
                <!-- Options Facebook/Email -->
                <div v-if="settings.enable_facebook && !showRegisterForm" class="auth-options">
                    <button
                        ref="btn_show_register"
                        id="btn_show_register"
                        class="auth-btn email-btn"
                        @click="onShowRegister"
                    >
                        <i class="fa fa-envelope" aria-hidden="true"></i>
                        <span>{{ $t('ingresaEmail') }}</span>
                    </button>

                    <div class="auth-divider">
                        <span>{{ $t('creandoUnaCuenta') }}</span>
                    </div>

                    <button
                        class="auth-btn facebook-btn"
                        @click="facebookLogin"
                        :disabled="fbLoading"
                    >
                        <i class="fa fa-facebook" aria-hidden="true"></i>
                        <span v-if="!fbLoading">Facebook</span>
                        <div class="spinner-white" v-if="fbLoading"></div>
                    </button>
                    
                    <div class="fb-terms">
                        {{ $t('alIngresarFacebook') }}
                        <router-link :to="{ name: 'cgu' }">{{ $t('tyc') }}</router-link>.
                    </div>
                </div>

                <!-- Formulaire d'inscription -->
                <div v-if="showRegisterForm" class="register-fields">
                <!-- Formulaire d'inscription -->
                <div v-if="showRegisterForm" class="register-fields">
                    <div class="campos-obligatorios">{{ $t('camposObligatorios') }}</div>

                    <!-- Ligne 1: Nom et Prénom -->
                    <div class="form-row">
                        <div class="form-group form-col">
                            <label for="txt_name">
                                {{ $t('nombre') }}
                                <span class="campo-obligatorio">*</span>
                            </label>
                            <input
                                :placeholder="$t('nombre')"
                                autofocus
                                v-jump
                                ref="txt_name"
                                name="txt_name"
                                maxlength="25"
                                type="text"
                                id="txt_name"
                                class="form-input"
                                v-model="name"
                                :class="{ 'has-error': nombreError.state }"
                            />
                            <span class="error" v-if="nombreError.state">
                                {{ nombreError.message }}
                            </span>
                        </div>

                        <div class="form-group form-col">
                            <label for="txt_surename">
                                {{ $t('apellido') }}
                                <span class="campo-obligatorio">*</span>
                            </label>
                            <input
                                :placeholder="$t('apellido')"
                                v-jump
                                ref="txt_surename"
                                name="txt_surename"
                                maxlength="25"
                                type="text"
                                id="txt_surename"
                                class="form-input"
                                v-model="sureName"
                                :class="{ 'has-error': apellidoError.state }"
                            />
                            <span class="error" v-if="apellidoError.state">
                                {{ apellidoError.message }}
                            </span>
                        </div>
                    </div>

                    <!-- Ligne 2: Email et Vérification Email -->
                    <div class="form-row">
                        <div class="form-group form-col">
                            <label for="txt_email">
                                {{ $t('email') }}
                                <span class="campo-obligatorio">*</span>
                            </label>
                            <input
                                :placeholder="$t('email')"
                                v-jump
                                ref="txt_email"
                                name="txt_email"
                                maxlength="40"
                                type="email"
                                id="txt_email"
                                class="form-input"
                                v-model="email"
                                :class="{ 'has-error': emailError.state }"
                            />
                            <span class="error" v-if="emailError.state">
                                {{ emailError.message }}
                            </span>
                        </div>

                        <div class="form-group form-col">
                            <label for="txt_email_verification">
                                {{ $t('emailVerification') }}
                                <span class="campo-obligatorio">*</span>
                            </label>
                            <input
                                :placeholder="$t('emailVerification')"
                                v-jump
                                ref="txt_email_verification"
                                name="txt_email_verification"
                                maxlength="40"
                                type="email"
                                id="txt_email_verification"
                                class="form-input"
                                v-model="emailVerification"
                                :class="{ 'has-error': emailVerificationError.state }"
                            />
                            <span class="error" v-if="emailVerificationError.state">
                                {{ emailVerificationError.message }}
                            </span>
                        </div>
                    </div>

                    <!-- Ligne 3: Année de naissance et Genre -->
                    <div class="form-row">
                        <div class="form-group form-col">
                            <label for="txt_birth_year">
                                Année de naissance
                            </label>
                            <input
                                :placeholder="'Ex: 1990'"
                                v-jump
                                ref="txt_birth_year"
                                name="txt_birth_year"
                                maxlength="4"
                                type="number"
                                id="txt_birth_year"
                                class="form-input"
                                v-model="birthYear"
                                :class="{ 'has-error': birthYearError.state }"
                            />
                            <span class="error" v-if="birthYearError.state">
                                {{ birthYearError.message }}
                            </span>
                        </div>

                        <div class="form-group form-col">
                            <label>
                                Genre
                                <span class="campo-obligatorio">*</span>
                            </label>
                            <div class="gender-options">
                                <label class="radio-label">
                                    <input
                                        type="radio"
                                        name="gender"
                                        value="male"
                                        v-model="gender"
                                    />
                                    <span>Homme</span>
                                </label>
                                <label class="radio-label">
                                    <input
                                        type="radio"
                                        name="gender"
                                        value="female"
                                        v-model="gender"
                                    />
                                    <span>Femme</span>
                                </label>
                                <label class="radio-label">
                                    <input
                                        type="radio"
                                        name="gender"
                                        value="other"
                                        v-model="gender"
                                    />
                                    <span>Autre</span>
                                </label>
                            </div>
                            <span class="error" v-if="genderError.state">
                                {{ genderError.message }}
                            </span>
                        </div>
                    </div>

                    <!-- Ligne 4: Mot de passe et Confirmation -->
                    <div class="form-row">
                        <div class="form-group form-col">
                            <label for="txt_password">
                                {{ $t('password') }}
                                <span class="campo-obligatorio">*</span>
                            </label>
                            <input
                                :placeholder="$t('password')"
                                v-jump
                                ref="txt_password"
                                name="txt_password"
                                maxlength="40"
                                type="password"
                                id="txt_password"
                                class="form-input"
                                v-model="password"
                                :class="{ 'has-error': passwordError.state }"
                            />
                            <span class="error" v-if="passwordError.state">
                                {{ passwordError.message }}
                            </span>
                        </div>

                        <div class="form-group form-col">
                            <label for="txt_password_confirmation">
                                {{ $t('ingresePassword') }}
                                <span class="campo-obligatorio">*</span>
                            </label>
                            <input
                                :placeholder="$t('ingresePassword')"
                                v-jump
                                ref="txt_password_confirmation"
                                name="txt_password_confirmation"
                                maxlength="40"
                                type="password"
                                id="txt_password_confirmation"
                                class="form-input"
                                v-model="passwordConfirmation"
                                :class="{ 'has-error': passwordError.state }"
                            />
                        </div>
                    </div>
                    </div>

                    <!-- Devenir conducteur validé -->
                    <div class="checkbox-container" v-if="settings.module_validated_drivers">
                        <label class="checkbox-label">
                            <input
                                v-jump
                                type="checkbox"
                                @change="changeBeDriver"
                                id="change_be_driver"
                            />
                            <span>{{ $t('solicitarChofer') }}</span>
                        </label>
                    </div>

                    <!-- Informations conducteur -->
                    <div v-if="settings.module_validated_drivers && showBeDriver" class="driver-section">
                        <div class="form-group">
                            <label for="driver_documentation">
                                {{ $t('ingresarDocumentacion') }}
                            </label>
                            <input
                                type="file"
                                id="driver_documentation"
                                class="form-input-file"
                                multiple
                                @change="onDriverDocumentChange"
                            />
                            <p class="help-text">{{ $t('requisitosRegister') }}</p>
                        </div>

                        <div class="form-group">
                            <label for="tipoDeCuenta">
                                {{ $t('tipoDeCuenta') }}
                                <span class="campo-obligatorio">*</span>
                            </label>
                            <select
                                v-model="account_type"
                                id="tipoDeCuenta"
                                class="form-input"
                                :class="{ 'has-error': accountTypeError.state }"
                            >
                                <option v-for="option in accountTypes" :value="option.id" :key="option.id">
                                    {{ option.name }}
                                </option>
                            </select>
                            <span class="error" v-if="accountTypeError.state">
                                {{ accountTypeError.message }}
                            </span>
                        </div>

                        <div class="form-group">
                            <label for="bancoDeCuenta">
                                {{ $t('bancoDeCuenta') }}
                                <span class="campo-obligatorio">*</span>
                            </label>
                            <select
                                v-model="account_bank"
                                id="bancoDeCuenta"
                                class="form-input"
                                :class="{ 'has-error': accountBankError.state }"
                            >
                                <option v-for="option in banks" :value="option.id" :key="option.id">
                                    {{ option.name }}
                                </option>
                            </select>
                            <span class="error" v-if="accountBankError.state">
                                {{ accountBankError.message }}
                            </span>
                        </div>

                        <div class="form-group">
                            <label for="accountNumber">
                                {{ $t('numeroDeCuenta') }}
                                <span class="campo-obligatorio">*</span>
                            </label>
                            <input
                                v-model="account_number"
                                type="text"
                                id="accountNumber"
                                class="form-input"
                                :placeholder="$t('numeroDeCuenta')"
                                :class="{ 'has-error': accountNumberError.state }"
                            />
                            <span class="error" v-if="accountNumberError.state">
                                {{ accountNumberError.message }}
                            </span>
                        </div>
                    </div>

                    <!-- Termes et conditions -->
                    <div class="terms-section">
                        <label class="checkbox-label">
                            <input
                                v-jump
                                ref="ipt_terms"
                                name="ipt_terms"
                                type="checkbox"
                                id="cbx_terms"
                                v-model="termsAndConditions"
                            />
                            <span>
                                {{ $t('leidoTerminos1') }}
                                <router-link :to="{ name: 'cgu' }">{{ $t('leidoTerminos2') }}</router-link>.
                            </span>
                        </label>

                        <button
                            v-jump
                            ref="ipt_submit"
                            name="ipt_submit"
                            @click="register"
                            class="submit-btn"
                            :disabled="progress || !termsAndConditions"
                            v-bind:data-sitekey="RECAPTCHA_SITE_KEY"
                        >
                            <template v-if="!progress">
                                <span>{{ $t('registrarme') }}</span>
                            </template>
                            <template v-else>
                                <div class="spinner-white"></div>
                                <span>Inscription en cours...</span>
                            </template>
                        </button>

                        <!-- Lien vers la page de connexion -->
                        <div class="login-link">
                            <span>Vous avez déjà un compte ? </span>
                            <router-link :to="{ name: 'login' }" class="link-primary">Connexion</router-link>
                        </div>
                    </div>
                </div>

                </div>

                <!-- Modal email déjà pris -->
                <modal
                    name="emailTakenModal"
                    v-if="showEmailTakenModal"
                    @close="toggleEmailTakenModal"
                >
                    <template #header>
                        <h3>
                            <span>{{ $t('emailYaTomado') }}</span>
                            <i
                                v-on:click="toggleEmailTakenModal"
                                class="fa fa-times float-right-close"
                            ></i>
                        </h3>
                    </template>
                    <template #body>
                        <div>
                            <div class="text-left color-black login-modal">
                                <p>{{ $t('emailYaTomadoDescripcion') }}</p>
                                <p>
                                    {{ $t('mesaAyudaFuncionaDesde') }}
                                    <a :href="'mailto:' + settings.admin_email">{{ settings.admin_email }}</a>,
                                    {{ $t('mensajePrivadoDe') }}
                                    <a href="https://instagram.com/carpoolear">Instagram</a>
                                    {{ $t('y') }}
                                    <a href="https://facebook.com/carpoolear">Facebook</a>.
                                </p>
                            </div>
                        </div>
                    </template>
                </modal>
            </div>

            <!-- Message de succès -->
            <div class="register-success" v-else>
                <div class="success-icon">
                    <i class="fa fa-check-circle"></i>
                </div>
                <h2>{{ $t('registroExitoso') }}</h2>
                
                <!-- Message pour compte non activé (avec email de vérification) -->
                <template v-if="!this.active">
                    <p class="success-message-main">{{ $t('enviadoCodigoVerificacionTitre') }}</p>
                    <p class="success-message-detail">{{ $t('enviadoCodigoVerificacionDetail') }}</p>
                    <p class="success-message-spam">{{ $t('enviadoCodigoVerificacionSpam') }}</p>
                </template>
                
                <!-- Message pour compte activé (ancien système, ne devrait plus arriver) -->
                <p v-else>{{ $t('usuarioRegistrado') }}</p>
                
                <router-link :to="{ name: 'login' }" class="login-redirect-btn">
                    <i class="fa fa-sign-in" aria-hidden="true"></i>
                    <span>Se connecter</span>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import dialogs from '../../services/dialogs.js';
import bus from '../../services/bus-event';
import router from '../../router';
import DatePicker from '../DatePicker';
import modal from '../Modal';
import dayjs from '../../dayjs';
import Spinner from '../Spinner.vue';
let emailRegex =
    /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
class Error {
    constructor(state = false, message = '') {
        this.state = false;
        this.message = '';
    }
}
console.log('RECAPTCHA_SECRET_KEY', process.env.RECAPTCHA_SITE_KEY);
export default {
    name: 'register',
    data() {
        return {
            active: false,
            email: '',
            emailVerification: '',
            password: '',
            passwordConfirmation: '',
            name: '',
            sureName: '',
            birthday: '',
            birthYear: '',
            gender: '',
            account_number: '',
            account_type: '',
            account_bank: '',
            termsAndConditions: false,
            carpoolear_logo:
                process.env.ROUTE_BASE +
                'static/img/' +
                process.env.TARGET_APP +
                '_logo.png',
            RECAPTCHA_SITE_KEY: process.env.RECAPTCHA_SITE_KEY,
            progress: false,
            success: false,
            emailError: new Error(),
            emailVerificationError: new Error(),
            passwordError: new Error(),
            nombreError: new Error(),
            apellidoError: new Error(),
            birthdayError: new Error(),
            birthYearError: new Error(),
            genderError: new Error(),
            accountNumberError: new Error(),
            accountTypeError: new Error(),
            accountBankError: new Error(),
            maxDate: dayjs().toDate(),
            minDate: dayjs('1900-01-01').toDate(),
            showBeDriver: false,
            driverFiles: null,
            banks: [],
            accountTypes: [],
            loading: false,
            fbLoading: false,
            showRegister: false,
            showEmailTakenModal: false
        };
    },
    computed: {
        ...mapGetters({
            checkLogin: 'auth/checkLogin',
            isMobile: 'device/isMobile',
            settings: 'auth/appConfig',
            registerData: 'profile/registerData'
        }),
        tripCardTheme() {
            return this.settings ? this.settings.trip_card_design : '';
        },
        showRegisterForm() {
            return !this.settings.enable_facebook || this.showRegister;
        }
    },
    watch: {
        email: function () {
            this.emailError.state = false;
        },
        emailVerification: function () {
            this.emailVerificationError.state = false;
        },
        name: function () {
            this.nombreError.state = false;
        },
        sureName: function () {
            this.apellidoError.state = false;
        },
        password: function () {
            this.passwordError.state = false;
        },
        birthdayAnswer: function () {
            this.birthdayError.state = false;
        },
        birthYear: function () {
            this.birthYearError.state = false;
        },
        gender: function () {
            this.genderError.state = false;
        }
    },
    components: {
        DatePicker,
        modal,
        Spinner
    },
    methods: {
        ...mapActions({
            doRegister: 'auth/register',
            getBankData: 'profile/getBankData',
            saveRegisterData: 'profile/saveRegisterData',
            cleanRegisterData: 'profile/cleanRegisterData',
            fbLogin: 'cordova/facebookLogin'
        }),
        onShowRegister() {
            this.showRegister = true;
        },
        toggleEmailTakenModal() {
            this.showEmailTakenModal = !this.showEmailTakenModal;
        },
        facebookLogin() {
            if (!this.loading) {
                this.fbLoading = true;
                this.fbLogin().catch((response) => {
                    if (response.errors && response.errors.email) {
                        dialogs.message(this.$t('correoUsado'), {
                            duration: 10,
                            estado: 'error'
                        });
                    }
                });
            } else {
                dialogs.message(this.$t('solicitudEnviada'), {
                    duration: 10,
                    estado: 'error'
                });
            }
        },
        validate() {
            let globalError = false;
            if (this.email.length < 1) {
                this.emailError.state = true;
                this.emailError.message = this.$t('olvidoEmail');
                globalError = true;
            } else if (!emailRegex.test(this.email)) {
                this.emailError.state = true;
                this.emailError.message = this.$t('ingreseEmailValido');
                globalError = true;
            }

            if (this.emailVerification.length < 1) {
                this.emailVerificationError.state = true;
                this.emailVerificationError.message = this.$t('olvidoEmail');
                globalError = true;
            } else if (!emailRegex.test(this.emailVerification)) {
                this.emailVerificationError.state = true;
                this.emailVerificationError.message =
                    this.$t('ingreseEmailValido');
                globalError = true;
            } else if (this.email !== this.emailVerification) {
                this.emailVerificationError.state = true;
                this.emailVerificationError.message =
                    this.$t('emailsNoCoinciden');
                globalError = true;
            }

            if (this.password.length < 1) {
                this.passwordError.state = true;
                this.passwordError.message = this.$t('olvidoContrasena');
                globalError = true;
            } else if (this.password.length < 8) {
                this.passwordError.state = true;
                this.passwordError.message = this.$t('contraCorta');
                globalError = true;
            } else if (this.passwordConfirmation < 1) {
                this.passwordError.state = true;
                this.passwordError.message = this.$t('olvidoConfirmarContra');
                globalError = true;
            } else if (this.password !== this.passwordConfirmation) {
                this.passwordError.state = true;
                this.passwordError.message = this.$t('contraNoCoinciden');
                globalError = true;
            }

            if (this.name.length < 1) {
                this.nombreError.state = true;
                this.nombreError.message = this.$t('olvidoNombre');
                globalError = true;
            }

            if (this.sureName.length < 1) {
                this.apellidoError.state = true;
                this.apellidoError.message = this.$t('olvidoApellido');
                globalError = true;
            }

            // Validation du genre (obligatoire)
            if (!this.gender || this.gender.length < 1) {
                this.genderError.state = true;
                this.genderError.message = 'Veuillez sélectionner votre genre.';
                globalError = true;
            }

            // Validation de l'année de naissance (optionnelle mais doit être valide si renseignée)
            if (this.birthYear && this.birthYear.length > 0) {
                const year = parseInt(this.birthYear);
                const currentYear = new Date().getFullYear();
                if (isNaN(year) || year < 1900 || year > currentYear) {
                    this.birthYearError.state = true;
                    this.birthYearError.message = 'Veuillez entrer une année valide.';
                    globalError = true;
                } else if (currentYear - year < 18) {
                    this.birthYearError.state = true;
                    this.birthYearError.message = 'Vous devez avoir au moins 18 ans.';
                    globalError = true;
                }
            }

            /* console.log(this.birthdayAnswer);
            if (!this.birthdayAnswer || this.birthdayAnswer.length < 1) {
                this.birthdayError.state = true;
                this.birthdayError.message = 'Olvido ingresar su fecha de nacimiento.';
                globalError = true;
            } else {
                let birthday = moment(this.birthdayAnswer);
                if (moment().diff(birthday, 'years') < 18) {
                    this.birthdayError.state = true;
                    this.birthdayError.message = 'Lo sentimos, debes ser mayor de edad para usar el servicio. Para más información te recomendamos leer los términos y condiciones.';
                    globalError = true;
                }
            } */

            if (this.settings.module_validated_drivers && this.showBeDriver) {
                if (!this.account_number) {
                    this.accountNumberError.state = true;
                    this.accountNumberError.message =
                        this.$t('campoObligatorio');
                    globalError = true;
                }
                if (!this.account_type) {
                    this.accountTypeError.state = true;
                    this.accountTypeError.message = this.$t('campoObligatorio');
                    globalError = true;
                }
                if (!this.account_bank) {
                    this.accountBankError.state = true;
                    this.accountBankError.message = this.$t('campoObligatorio');
                    globalError = true;
                }
            }
            return globalError;
        },
        onDriverDocumentChange(event) {
            console.log('file input ', event);
            if (event.target.files) {
                this.driverFiles = event.target.files;
            }
        },
        changeBeDriver() {
            this.showBeDriver = !this.showBeDriver;
        },
        dateChange(value) {
            this.birthdayAnswer = value;
        },
        jumpToError() {
            let hasError = document.getElementsByClassName('has-error');
            if (hasError.length) {
                let element = hasError[0];
                this.$scrollToElement(element);
            }
        },
        register(event) {
            const that = this;
            grecaptcha.ready(function () {
                grecaptcha
                    .execute(process.env.RECAPTCHA_SITE_KEY, {
                        action: 'submit'
                    })
                    .then(function (token) {
                        // Add your logic to submit to your backend server here.
                        if (that.validate()) {
                            // Jump To Error
                            that.$nextTick(() => {
                                that.jumpToError();
                                dialogs.message(that.$t('debeCorregirCampos'), {
                                    duration: 10,
                                    estado: 'error'
                                });
                            });
                            return;
                        }
                        that.progress = true;
                        let data = {
                            email: that.email,
                            password: that.password,
                            password_confirmation: that.passwordConfirmation,
                            name: that.name + ' ' + that.sureName,
                            terms_and_conditions: that.termsAndConditions,
                            birthday: that.birthdayAnswer,
                            birth_year: that.birthYear,
                            gender: that.gender,
                            account_number: that.account_number,
                            account_type: that.account_type,
                            account_bank: that.account_bank,
                            token
                        };
                        /* global FormData */
                        let bodyFormData = new FormData();
                        for (const key in data) {
                            if (data.hasOwnProperty(key)) {
                                bodyFormData.append(key, data[key]);
                            }
                        }
                        if (that.driverFiles) {
                            bodyFormData.append('user_be_driver', true);
                            console.log('file', that.driverFiles);
                            for (
                                let index = 0;
                                index < that.driverFiles.length;
                                index++
                            ) {
                                const file = that.driverFiles[index];
                                console.log('file', file);
                                bodyFormData.append('driver_data_docs[]', file);
                            }
                        }
                        that.doRegister(bodyFormData)
                            .then((registerData) => {
                                if (
                                    registerData &&
                                    registerData.data &&
                                    registerData.data.active
                                ) {
                                    that.active = true;
                                }
                                that.progress = false;
                                that.success = true;
                            })
                            .catch((err) => {
                                console.log('catch', err);
                                if (err) {
                                    console.log('err register', err);
                                    if (err.status === 422) {
                                        console.log(
                                            'err st',
                                            err.data.errors.email
                                        );
                                        const emailErrorMsg =
                                            err.data.errors.email[0] || '';
                                        const isEmailTaken =
                                            emailErrorMsg.indexOf(
                                                'been taken'
                                            ) >= 0 ||
                                            emailErrorMsg.indexOf(
                                                'ya ha sido tomado'
                                            ) >= 0;
                                        if (
                                            err.data &&
                                            err.data.errors &&
                                            err.data.errors.email &&
                                            Array.isArray(
                                                err.data.errors.email
                                            ) &&
                                            err.data.errors.email.length > 0 &&
                                            isEmailTaken
                                        ) {
                                            that.showEmailTakenModal = true;
                                            that.emailError.state = true;
                                            that.emailError.message =
                                                that.$t('emailYaTomado');
                                            that.jumpToError();
                                        } else {
                                            dialogs.message(
                                                that.$t('debeCorregirCampos'),
                                                {
                                                    estado: 'error'
                                                }
                                            );
                                        }
                                    } else {
                                        dialogs.message(
                                            that.$t('errorRegistro'),
                                            {
                                                estado: 'error'
                                            }
                                        );
                                    }
                                }
                                that.progress = false;
                            });
                    });
            });
        },
        onBackClick() {
            router.back();
        }
    },
    mounted() {
        bus.on('back-click', this.onBackClick);
        bus.on('date-change', this.dateChange);
        if (this.registerData) {
            Object.assign(this, this.registerData);
        }
        this.getBankData().then((data) => {
            console.log('get bank data', data);
            this.banks = data.banks;
            this.accountTypes = data.cc;
        });

        let recaptchaScript = document.createElement('script');
        recaptchaScript.setAttribute(
            'src',
            `https://www.google.com/recaptcha/api.js?render=${process.env.RECAPTCHA_SITE_KEY}`
        );
        document.head.appendChild(recaptchaScript);
    },

    beforeDestroy() {
        console.log(this.$route.name);
        if (this.$route.name === 'terms') {
            this.saveRegisterData(this.$data);
        } else {
            this.cleanRegisterData();
        }
        bus.off('back-click', this.onBackClick);
        bus.off('date-change', this.dateChange);
    }
};
</script>

<style>
/* Force le fond vert sur toute la page de register */
body {
    background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%) !important;
    min-height: 100vh;
}

/* Force également sur l'app-container pour la page register */
.app-container:has(.register-page) {
    min-height: 100vh !important;
    background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%) !important;
}
</style>

<style scoped>
/* === Layout Principal === */
.register-page {
    position: relative;
    min-height: 100vh;
    display: flex;
    margin-top: -90px;
    align-items: center;
    justify-content: center;
    padding: 10px 20px 20px;
    font-family: 'Heebo', 'Poppins', sans-serif;
}

/* Fond vert qui couvre tout */
.register-page::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
    z-index: -1;
}

.register-container {
    width: 100%;
    max-width: 700px;
    background: white;
    border-radius: 20px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
    padding: 40px 35px;
    animation: fadeIn 0.5s ease;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* === Header === */
.register-header {
    text-align: center;
    margin-bottom: 30px;
}

.logo-link {
    text-decoration: none;
}

.app-name {
    font-family: 'Poppins', 'Heebo', sans-serif;
    font-size: 36px;
    font-weight: 700;
    color: #59c362;
    margin: 0 0 10px 0;
    letter-spacing: -0.5px;
}

.register-subtitle {
    font-size: 18px;
    font-weight: 500;
    color: #666;
    margin: 0;
}

/* === Formulaire === */
.register-form {
    width: 100%;
}

.register-fields {
    width: 100%;
}

.campos-obligatorios {
    font-size: 13px;
    color: #d32f2f;
    margin-bottom: 20px;
    font-weight: 500;
}

/* === Grille 2 colonnes === */
.form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-bottom: 0;
}

.form-col {
    min-width: 0; /* Permet au contenu de se rétrécir si nécessaire */
}

.form-group {
    margin-bottom: 20px;
}

.form-group label {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin-bottom: 8px;
    font-family: 'Heebo', sans-serif;
}

.campo-obligatorio {
    color: #d32f2f;
    margin-left: 3px;
}

.form-input {
    width: 100%;
    height: 50px;
    padding: 12px 15px;
    border: 2px solid #e0e0e0;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 500;
    font-family: 'Heebo', sans-serif;
    transition: all 0.3s ease;
    box-sizing: border-box;
}

.form-input:focus {
    outline: none;
    border-color: #59c362;
    border: 2px solid #59c362;
}

.form-input.has-error {
    border-color: #d32f2f;
}

.form-input-file {
    width: 100%;
    padding: 10px;
    border: 2px dashed #e0e0e0;
    border-radius: 10px;
    font-size: 14px;
    font-family: 'Heebo', sans-serif;
    cursor: pointer;
}

.error {
    display: block;
    font-size: 12px;
    color: #d32f2f;
    margin-top: 5px;
    font-weight: 500;
}

.help-text {
    font-size: 12px;
    color: #666;
    margin-top: 5px;
    font-style: italic;
}

/* === Select === */
select.form-input {
    cursor: pointer;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23333' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 15px center;
    padding-right: 40px;
}

/* === Checkbox === */
.checkbox-container {
    margin: 20px 0;
}

.checkbox-label {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    font-size: 14px;
    color: #333;
}

.checkbox-label input[type="checkbox"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
    accent-color: #59c362;
}

/* === Radio buttons pour le genre === */
.gender-options {
    display: flex;
    gap: 15px;
    margin-top: 8px;
    flex-wrap: wrap;
}

.radio-label {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    color: #333;
    padding: 8px 12px;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    transition: all 0.3s ease;
    background: white;
}

.radio-label:hover {
    border-color: #59c362;
    background: #f0f9f1;
}

.radio-label input[type="radio"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
    accent-color: #59c362;
}

.radio-label input[type="radio"]:checked + span {
    color: #59c362;
    font-weight: 600;
}

.radio-label:has(input[type="radio"]:checked) {
    border-color: #59c362;
    background: #f0f9f1;
}


/* === Section conducteur === */
.driver-section {
    background: #f8f9fa;
    padding: 20px;
    border-radius: 10px;
    margin: 20px 0;
}

/* === Section termes === */
.terms-section {
    margin-top: 25px;
    padding-top: 20px;
    border-top: 1px solid #e0e0e0;
}

.terms-section .checkbox-label {
    margin-bottom: 20px;
}

.terms-section a {
    color: #59c362;
    font-weight: 600;
    text-decoration: none;
}

.terms-section a:hover {
    text-decoration: underline;
}

/* === Bouton de soumission === */
.submit-btn {
    width: 100%;
    height: 50px;
    background: linear-gradient(135deg, #59c362 0%, #48a551 100%);
    border: none;
    border-radius: 10px;
    color: white;
    font-size: 16px;
    font-weight: 600;
    font-family: 'Heebo', sans-serif;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.submit-btn:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(89, 195, 98, 0.3);
}

.submit-btn:active:not(:disabled) {
    transform: translateY(0);
}

.submit-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* === Options d'authentification === */
.auth-options {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-bottom: 25px;
}

.auth-btn {
    width: 100%;
    height: 50px;
    border: none;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 600;
    font-family: 'Heebo', sans-serif;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.email-btn {
    background: #444;
    color: white;
}

.email-btn:hover {
    background: #333;
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.facebook-btn {
    background: #1877f2;
    color: white;
}

.facebook-btn:hover:not(:disabled) {
    background: #0c63d4;
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(24, 119, 242, 0.3);
}

.facebook-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.auth-divider {
    text-align: center;
    margin: 10px 0;
    position: relative;
}

.auth-divider span {
    background: white;
    padding: 0 15px;
    font-size: 14px;
    color: #666;
    position: relative;
    z-index: 1;
}

.auth-divider::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 1px;
    background: #e0e0e0;
    z-index: 0;
}

.fb-terms {
    font-size: 12px;
    color: #666;
    text-align: center;
    margin-top: 10px;
}

.fb-terms a {
    color: #59c362;
    text-decoration: none;
    font-weight: 600;
}

.fb-terms a:hover {
    text-decoration: underline;
}

/* === Message de succès === */
.register-success {
    text-align: center;
    padding: 30px 20px;
}

.success-icon {
    font-size: 64px;
    color: #59c362;
    margin-bottom: 20px;
}

.register-success h2 {
    font-size: 24px;
    font-weight: 700;
    color: #333;
    margin: 0 0 15px 0;
}

.register-success p {
    font-size: 16px;
    color: #666;
    line-height: 1.6;
    margin: 0 0 25px 0;
}

.success-message-main {
    font-size: 17px;
    font-weight: 600;
    color: #333 !important;
    margin-bottom: 15px !important;
}

.success-message-detail {
    font-size: 16px;
    color: #555 !important;
    margin-bottom: 15px !important;
}

.success-message-spam {
    font-size: 14px;
    color: #888 !important;
    font-style: italic;
    margin-bottom: 25px !important;
}

.login-redirect-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin-top: 10px;
    padding: 14px 35px;
    background: linear-gradient(135deg, #59c362 0%, #48a551 100%);
    color: white;
    text-decoration: none;
    border-radius: 10px;
    font-size: 16px;
    font-weight: 600;
    font-family: 'Heebo', sans-serif;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(89, 195, 98, 0.2);
}

.login-redirect-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(89, 195, 98, 0.3);
}

.login-redirect-btn:active {
    transform: translateY(0);
}

.login-redirect-btn i {
    font-size: 18px;
}

/* === Spinner === */
.spinner-white {
    display: inline-block;
    width: 18px;
    height: 18px;
    border: 3px solid rgba(255, 255, 255, 0.3);
    border-top-color: white;
    border-radius: 50%;
    animation: spinner-rotate 0.8s linear infinite;
}

@keyframes spinner-rotate {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

/* === Responsive === */
@media (max-width: 768px) {
    .register-container {
        padding: 30px 25px;
    }

    .app-name {
        font-size: 28px;
    }

    .register-subtitle {
        font-size: 16px;
    }

    .form-input {
        height: 48px;
        font-size: 14px;
    }

    .submit-btn {
        height: 48px;
        font-size: 15px;
    }

    /* Passer en une seule colonne sur mobile */
    .form-row {
        grid-template-columns: 1fr;
        gap: 0;
    }

    .gender-options {
        gap: 10px;
    }

    .radio-label {
        padding: 6px 10px;
        font-size: 13px;
    }
}

/* === Lien vers la page de connexion === */
.login-link {
    text-align: center;
    margin-top: 20px;
    font-size: 14px;
    color: #666;
}

.login-link .link-primary {
    color: #59c362;
    text-decoration: none;
    font-weight: 600;
    transition: all 0.3s ease;
}

.login-link .link-primary:hover {
    color: #47a352;
    text-decoration: underline;
}
</style>
